import { Link } from "react-router-dom"
import { ChevronRight } from "lucide-react"

interface PageHeroProps {
  title: string
  subtitle?: string
  description?: string
  breadcrumbs?: { label: string; href?: string }[]
}

export function PageHero({ title, subtitle, description, breadcrumbs }: PageHeroProps) {
  return (
    <section className="relative bg-brand-900 dark:bg-brand-950 text-white overflow-hidden">
      <div className="absolute inset-0 pattern-dots opacity-30" />
      <div className="absolute -top-32 -right-32 w-96 h-96 bg-gold-500/10 rounded-full blur-3xl" />
      <div className="absolute -bottom-32 -left-32 w-96 h-96 bg-brand-500/10 rounded-full blur-3xl" />
      <div className="container mx-auto px-4 py-16 md:py-24 relative">
        {breadcrumbs && breadcrumbs.length > 0 && (
          <nav className="flex items-center gap-1.5 text-xs text-white/70 mb-4">
            {breadcrumbs.map((b, i) => (
              <span key={i} className="flex items-center gap-1.5">
                {b.href ? <Link to={b.href} className="hover:text-gold-300">{b.label}</Link> : <span>{b.label}</span>}
                {i < breadcrumbs.length - 1 && <ChevronRight className="w-3 h-3" />}
              </span>
            ))}
          </nav>
        )}
        {subtitle && (
          <div className="inline-block text-xs font-semibold uppercase tracking-widest text-gold-300 mb-3 px-3 py-1 rounded-full bg-white/10 border border-white/10">
            {subtitle}
          </div>
        )}
        <h1 className="font-display text-3xl md:text-5xl font-bold leading-tight max-w-3xl">{title}</h1>
        {description && <p className="mt-5 text-base md:text-lg text-white/80 max-w-2xl leading-relaxed">{description}</p>}
      </div>
    </section>
  )
}
